
import { useTranslation } from "react-i18next";
import React from "react";
import imageUrl from "utils/imageUrl";
import detectLang from "utils/detectLang";
import { useParams } from "react-router-dom";
import _html from "utils/_html";
import cmsImage from "utils/cmsImage";
import Question from "components/Question";

const OpenPitch = ({ subTab, openPitch, categories }) => {
  const { t } = useTranslation();
  const { lang: _lang } = useParams();

  
  const lang = _lang || "en";
  return (
    <>
      <div ref={openPitch} className="open-pitch">
        {categories?.map((item, _ind) => {
          return (
            <>
              {item?.services?.map((sub, sub_index) => {
                return (
                  <>
                    {subTab === sub?.id && (
                      
                      <>
                        <section key={_ind}>
                          <dl>{_html(detectLang(sub, "description", lang))}</dl>
                        </section>
                      </>
                    )}
                  </>
                );
              })}
            </>
          );
        })}
      </div>
      {/* <div ref={openPitch} className="open-pitch">
      <Question title="Problem Java Times Caffe is solving" para="We have Build our business from ground up using Blockchain technology has the potential to be used in a variety of ways in the coffee shop industry, and there are a few specific ways in which it could be used to create a successful coffee shop solution." />
      <Question title="Problem Java Times Caffe is solving" para="We have Build our business from ground up using Blockchain technology has the potential to be used in a variety of ways in the coffee shop industry, and there are a few specific ways in which it could be used to create a successful coffee shop solution." />
      <Question title="Problem Java Times Caffe is solving" para="We have Build our business from ground up using Blockchain technology has the potential to be used in a variety of ways in the coffee shop industry, and there are a few specific ways in which it could be used to create a successful coffee shop solution." />
      </div> */}
    </>
  );
};

export default OpenPitch;
